module.exports = __webpack_public_path__ + "img/ring_g_0_1_1.5b6bf161.png";